import axios from 'axios'
import AppConfigs from './config'
const {
  serverConfig: { defaultRoute, host, port, user },
} = AppConfigs

const serverUrls = {
  getHost: () => host,
  getPort: () => port,
  getDefaulUrl: () => `${host}:${port}/${defaultRoute}`,

  getAuthUrl() {
    return `${this.getDefaulUrl()}/${user}`
  },
}

export const getServerCore = () => {
  return {
    serverUrls,
  }
}

export const UploadFileApi = async (formData) => {
  let defaultUrl = serverUrls.getDefaulUrl()
  const { data } = await axios({
    method: 'POST',
    url: `${defaultUrl}/uploadImage`,
    data: formData,
    'Access-Control-Allow-Origin': '*',
  })
  return data
}